import axios from 'axios'
import urlBase from './UrlBase'; 



export const post = async ({url, data}) =>{

    try {
        let consulta = await axios({
            method: 'post',
            url: urlBase+url,
            data: data,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
    
        let resultado = consulta.data; 
    
        return resultado; 
    } catch (error) {

        throw error;
    }

}


export default {post}



